import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { EditStartProjectDetailInput, EmployeeDropdownResult, ProjectStatus, Result, StartProjectDetailInput, StartProjectDetailResult } from 'app/models';
import { StartProjectDetailService } from 'app/services';
import { Utility } from 'app/shared';

@Component({
  selector: 'app-start-project-detail',
  templateUrl: './start-project-detail.component.html',
  styleUrls: ['./start-project-detail.component.scss']
})
export class StartProjectDetailComponent implements OnInit {

  public result = new Result();
  public projectStatus = ProjectStatus;
  public token = Utility.getTokenType();
  public isBusy = false;
  public startProjectDetailForDisplay = new StartProjectDetailResult();
  public titleText = 'Information';
  public name = '';
  public description = '';
  public order: number | null = null;

  public nameIsInvalid = false;
  public orderIsInvalid = false;

  @Input()
  public set startProjectDetail(value: StartProjectDetailResult) {
    this.startProjectDetailForDisplay = value;
    this.resetIsInvalidVariables();
    this.name = '';
    this.order = null;
    this.description = '';
    this.editMode = false;
    this.add = false;
    if (this.startProjectDetailForDisplay.id === 0) {
      this.add = true;
    }
  }

  add = false;
  editMode = false;

  @Input()
  employeeDropdown = new Array<EmployeeDropdownResult>();

  @Output()
  private reloadData = new EventEmitter<void>();

  constructor(private startProjectDetailService: StartProjectDetailService,
    private _coreSidebarService: CoreSidebarService) { }

  ngOnInit(): void {
  }

  public assigned(employeeId: number): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      this.startProjectDetailService.updateAssignee(this.startProjectDetailForDisplay.id, employeeId).then(result => {
        if (result.success === true) {
          this.reloadData.emit();
          this.result = new Result();
          this.result.success = true;
          this.result.message = Utility.TransactionCompletedSuccessfully;
          this.toggleSidebar();
        } else {
          this.startProjectDetailForDisplay.assignedEmployeeId = null;
          this.result = result;
        }
      }).finally(() => {
        this.isBusy = false;
      });
    }
  }

  public changeProjectStatus(): void {
    this.startProjectDetailService.updateProjectStatus(this.startProjectDetailForDisplay.id, this.startProjectDetailForDisplay.projectStatus).then(result => {
      if (result.success === true) {
        this.reloadData.emit();
        this.result = new Result();
        this.result.success = true;
        this.result.message = Utility.TransactionCompletedSuccessfully;
        this.toggleSidebar();
      } else {
        this.result = result;
      }
    });
  }

  public toggleSidebar(): void {
    this.add = false;
    this.editMode = false;
    this._coreSidebarService.getSidebarRegistry('start-project-detail')!.toggleOpen();
  }

  public changeToEditMode(): void {
    this.editMode = !this.editMode;
    if (this.editMode === false) {
      this.titleText = 'Information';
    } else {
      this.titleText = 'Edit';
      this.name = this.startProjectDetailForDisplay.title;
      this.description = this.startProjectDetailForDisplay.description;
      this.order = this.startProjectDetailForDisplay.order;
    }
  }

  public submit(): void {
    if (this.validation() === true) {
      if (this.add === true) {
        this.onAdd();
      } else {
        this.edit();
      }
    }
  }

  private validation(): boolean {
    let isValid = true;
    this.result = new Result();
    this.result.message = '';

    this.resetIsInvalidVariables();

    if (this.name === null || this.name.trim() === '') {
      isValid = false;
      this.nameIsInvalid = true;
    }

    if (this.order === null || this.order.toString().trim() === '') {
      isValid = false;
      this.orderIsInvalid = true;
    }
    // if (isValid === false)
    //   this.result.Success = false;
    return isValid;
  }

  private onAdd(): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      const temp: StartProjectDetailInput = {
        title: this.name,
        description: this.description,
        order: this.order ?? 0,
        startProjectId: this.startProjectDetailForDisplay.startProjectId
      };
      this.startProjectDetailService.addStartProjectDetail(temp).then(
        result => {
          this.isBusy = false;
          this.result = result;
          if (this.result.success === true) {
            this.result.message = Utility.AddOperationMessage;
            this.reloadData.emit();
            this.toggleSidebar();
          }
        }).catch(() => {
          this.isBusy = false;
        });
    }
  }

  public edit(): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      const temp: EditStartProjectDetailInput = {
        title: this.name,
        description: this.description,
        order: this.order ?? 0
      };

      this.startProjectDetailService.editStartProjectDetail(this.startProjectDetailForDisplay.id ?? 0, temp).then(
        result => {
          this.isBusy = false;
          this.result = result;
          if (this.result.success === true) {
            this.result.message = Utility.EditOperationMessage;
            this.reloadData.emit();
            this.toggleSidebar();
          }
        }).catch(() => {
          this.isBusy = false;
        });
    }
  }

  private resetIsInvalidVariables(): void {
    this.nameIsInvalid = false;
    this.orderIsInvalid = false;
  }
}
